export const INSURER_CODES = Object.freeze({
    irishLife: 'IRIL',
    royalLondon: 'ROYLI'
})

export const appendReferToAttachmentsOption = (options) => [...options, 'Refer to attachments']

export const yesNoOptions = ['Yes', 'No']
export const yesNoValidOptions = appendReferToAttachmentsOption(yesNoOptions)